import { globalTourSteps } from 'constants/tour';

export const nodeListTourId = 'node-list';

export const tourSteps = {
  tableRow: 'table-row',
  resourceOfferingCell: 'resource-offering-cell',
};

export const nodeListTourStepsOrder = [
  tourSteps.tableRow,
  tourSteps.resourceOfferingCell,
  globalTourSteps.connectMyCluster,
];
